import styled from 'styled-components';

export const LoadingContainer = styled.div`
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;
